export const newRome600 = [
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/cc0ca2d14290c454e738ea44bc4f14d0f1cb3c3e5669db26f6e053db.jpg",
    type: "Room",
    available: "From 28 March",
    title: "Bed in shared room in 3-bedroom apartment in Rome",
    rent: "100-270 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/609169?move-in=2022-06-30",
    permonth: "/month",
    id: 1,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/15c902a4c40bb0343a3f610a6aaae3eacd0c031e2af1614185a4af25.jpg",
    type: "Room",
    available: "From 28 March",
    title: "Bed in shared room in 3-bedroom apartment in Rome",
    rent: "197-270 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/115513?move-in=2022-06-30",
    permonth: "/month",
    id: 2,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/479134ff670ce6882209533ece4843a1302d24de898ada36c106608b.jpg",
    type: "Room",
    available: "From 1 May",
    title: "Bed in shared room in 3-bedroom apartment in Rome",
    rent: "197-270 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/609168?move-in=2022-06-30",
    permonth: "/month",
    id: 3,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/cff80a820dfc1b64e7cfe2c7eed1e0e9ae6461d3558193bb59ab0e51.jpg",
    type: "Room",
    available: "From 6 April",
    title: "Beds for rent in 4-bedroom apartment in Torre Angela, Rome",
    rent: "270 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/210086?move-in=2022-06-30",
    permonth: "/month",
    id: 4,
  },
  {
    type: "Room",
    available: "From 28 March",
    title: "Bed for rent in apartment with 2 bedrooms in Pigneto, Rome",
    rent: "280 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/660599?move-in=2022-06-30",
    permonth: "/month",
    id: 5,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/53b452be7334c34913da7b7245083cb79c8cacb1b4cf54891692f0f8.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Bed for rent in shared room in Portuense, Rome",
    rent: "290 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/407956?move-in=2022-06-30",
    permonth: "/month",
    id: 6,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/e3b462752c08e08f31513f242b7917be043eb619e31193c29d07b032.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Bed in bright room in apartment in San Giovanni, Rome",
    rent: "290-315 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/113103?move-in=2022-06-30",
    permonth: "/month",
    id: 7,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/024b401a06ead04fa646e1b1b36ab3ce1ad9c4b14f6c45cf9230b0c8.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Room for rent in 4-bedroom apartment in Acilia, Rome",
    rent: "295 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/245462?move-in=2022-06-30",
    permonth: "/month",
    id: 8,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/d58d7ac70d3bb42b5a0c1ccc7b771bc9df3f9b3035c03b5b75ad8dae.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Double bed in room in 2-bedroom apartment, Monteverde, Rome",
    rent: "298-398 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/154345?move-in=2022-06-30",
    permonth: "/month",
    id: 9,
  },
  {
    veified: "CHECKED",
    type: "Room",
    available: "From 1 May",
    title: "Bed for rent in a shared room  in San Giovanni, Rome",
    rent: "300 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/651635?move-in=2022-06-30",
    permonth: "/month",
    id: 10,
  },
  {
    veified: "CHECKED",
    type: "Room",
    available: "From 1 May",
    title: "Bed for rent in a shared room  in San Giovanni, Rome",
    rent: "300 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/651636?move-in=2022-06-30",
    permonth: "/month",
    id: 11,
  },
  {
    veified: "CHECKED",
    type: "Room",
    available: "From 1 May",
    title: "Bed for rent in a shared room  in San Giovanni, Rome",
    rent: "300 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/651637?move-in=2022-06-30",
    permonth: "/month",
    id: 12,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/a80acde53b740d3122ad9d202c41c5dafac84622c5b5548e4994cb90.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Cosy room in 2-bedroom apartment in Villa Verde, Rome",
    rent: "300 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/264315?move-in=2022-06-30",
    permonth: "/month",
    id: 13,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/de214c3d8b2b4b2b71e4c66b2454b159b4f6dce120b74079789fe7e3.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Bed for rent in a shared room  in San Giovanni, Rome",
    rent: "300 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/90527?move-in=2022-06-30",
    permonth: "/month",
    id: 14,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/f027a19e6c15bc6317a04cbf4d52167a1f1420a62be72fb249ad96cc.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Bed for rent in a shared room  in San Giovanni, Rome",
    rent: "300 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/89286?move-in=2022-06-30",
    permonth: "/month",
    id: 15,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/f53edf5f6a0c497efce09f28f40115817bfa7b7220cdaddcf5cb751f.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Furnished room in 9-bedroom apartment in Aurelio, Rome",
    rent: "325 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/296986?move-in=2022-06-30",
    permonth: "/month",
    id: 16,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/6cc25e32051c544b7af137415e8915677298e55b9256a80aa69c0bf3.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Room for rent in 4-bedroom apartment in Trieste, Rome",
    rent: "330 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/411837?move-in=2022-06-30",
    permonth: "/month",
    id: 17,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/9cae96db1a117ff08c9d2966d393975803d0048c4df6a8c1cb0241fb.jpg",
    type: "Room",
    available: "From 29 March",
    title: "Furnished room in 6-bedroom apartment in Ostiense, Rome",
    rent: "335 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/296850?move-in=2022-06-30",
    permonth: "/month",
    id: 18,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/87adc19b473707cfc8e943cf81ade226d4fb113a6837f7057c5e38e8.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Room for rent in 4-bedroom apartment in Acilia, Rome",
    rent: "345 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/245460?move-in=2022-06-30",
    permonth: "/month",
    id: 19,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/4cd8a7099a2383a08b0ac2c6788c96e0b146b833f3449f4ec5cd608b.jpg",
    type: "Room",
    available: "From 1 May",
    title: "Rooms for rent in 5-bedroom apartment in Tuscolano, Rome",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/146924?move-in=2022-06-30",
    permonth: "/month",
    id: 20,
  },
  {
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/7f31cd25d0ed91a2c57995c97fe20dcd40e9c09a7d285e065fe357e3.jpg",
    type: "Room",
    available: "From 16 May",
    title: "Room for rent in apartment with 4 bedrooms in Rome",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/585414?move-in=2022-06-30",
    permonth: "/month",
    id: 21,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/dd673ccdb3e056b7dccda85a308b933dbb53767e7c0e824d7adaa130.jpg",
    type: "Room",
    available: "From 16 May",
    title: "Double room in 3-bedroom apartment in San Giovanni, Rome",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/114384?move-in=2022-06-30",
    permonth: "/month",
    id: 22,
  },
  {
    veified: "CHECKED",
    type: "Room",
    available: "From 21 May",
    title: "Modern room in 4-bedroom apartment in Tor Pignattara, Rome",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/96879?move-in=2022-06-30",
    permonth: "/month",
    id: 23,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/9c800f47f9618ae150941aca6859638d48401ff2ef6396dd4469bac7.jpg",
    type: "Room",
    available: "From 26 May",
    title: "Single room in 2-bedroom apartment in Trionfale, Rome",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/139225?move-in=2022-06-30",
    permonth: "/month",
    id: 24,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/b7444c960a2b6b1da0e56a6263d86ada98bc6c7621baf19a91cfc300.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Furnished room in apartment in EUR, Rome",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/105726?move-in=2022-06-30",
    permonth: "/month",
    id: 25,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/4a825119fc286636fee02153242d27696558c52e3fc84edc10267971.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Spacious room in apartment in Tuscolano, Rome",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/92451?move-in=2022-06-30",
    permonth: "/month",
    id: 26,
  },
  {
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/524824e0bc01226bc176a08ebb43cad882cd25bfa99abc4f4fcffdeb.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Room in shared apartment in Rome",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/586702?move-in=2022-06-30",
    permonth: "/month",
    id: 27,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/95b09353f93ca6e1fdff8a16ba3c0d611c8e8cbb84a1cc57087cdc89.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Big room in 3-bedroom apartment in Centocelle, Rome",
    rent: "350-400 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/144957?move-in=2022-06-30",
    permonth: "/month",
    id: 28,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/cd1c8e7a17839919aa04f1645e23a896f68bc61aa174c86d1c13be7a.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Single room in apartment in Monte Mario Trionfale, Rome",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/126860?move-in=2022-06-30",
    permonth: "/month",
    id: 29,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/3b61e433c40815835e1c722ffc5d754c17976dbbc8943f746c908167.jpg",
    type: "Room",
    available: "From 4 June",
    title: "Rooms for rent in 4-bedroom apartment in Monteverde, Rome",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/153624?move-in=2022-06-30",
    permonth: "/month",
    id: 30,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/add8536cac42ecd5b01a242664c6f6a1cc6b239fd0f9784da78ffd7f.jpg",
    type: "Room",
    available: "From 16 June",
    title: "Spacious bedroom in 3-bedroom apartment in Rome",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/147409?move-in=2022-06-30",
    permonth: "/month",
    id: 31,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/689e39a07c02796eee827e715111d84d083ab6600bf8b42f1180dd47.jpg",
    type: "Room",
    available: "From 21 June",
    title: "Shared room in 4-bedroom house, Belvedere, Rome",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/146684?move-in=2022-06-30",
    permonth: "/month",
    id: 32,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/c55be523b8aa4609a7346ec8134299bfd720a7c25e23a076af16efe9.jpg",
    type: "Room",
    available: "From 21 June",
    title: "Sunny room for rent in apartment with 4 bedrooms, Trieste",
    rent: "350-500 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/89929?move-in=2022-06-30",
    permonth: "/month",
    id: 33,
  },
  {
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/e27b156bacef4484501cceb9b933445278b60014ca189956ec5da35c.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Room for rent in 3-bedroom apartment in Rome",
    rent: "360 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/354887?move-in=2022-06-30",
    permonth: "/month",
    id: 34,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/3b2b657cd653bb4556ca4d0a893881f916851b89393ad86b3e472953.jpg",
    type: "Room",
    available: "From 16 June",
    title: "Room for rent in apartment with 4 bedrooms in Rome",
    rent: "360 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/252987?move-in=2022-06-30",
    permonth: "/month",
    id: 35,
  },
  {
    veified: "CHECKED",
    type: "Room",
    available: "From 2 May",
    title: "Spacious room in 4-bedroom apartment in Giardinetti, Rome",
    rent: "370 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/101283?move-in=2022-06-30",
    permonth: "/month",
    id: 36,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/4049a200ae6ed782af94b4acdc99c280d698df8d1fcdf40c7b356465.jpg",
    type: "Room",
    available: "From 15 May",
    title: "Stylish room in apartment in Monteverde, Rome",
    rent: "370 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/119816?move-in=2022-06-30",
    permonth: "/month",
    id: 37,
  },
  {
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/23a1908181b4778b80822cd6e12bc69ed7bd5b0e0c93564a5706ceae.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Room for rent in 3-bedroom apartment in Rome",
    rent: "370 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/354888?move-in=2022-06-30",
    permonth: "/month",
    id: 38,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/e6be1dcb5701b80fc748190e7a429453f38ae9481e7468588ef2c094.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Tidy room for rent in 5-bedroom apartment in Ostiense, Rome",
    rent: "370 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/292796?move-in=2022-06-30",
    permonth: "/month",
    id: 39,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/1bc1f0855ed8441e9123c83df1fdb135bf799ab37b9a7500f9805f95.jpg",
    type: "Room",
    available: "From 16 June",
    title: "Room in 4-bedroom apartment in Spinaceto",
    rent: "370 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/252986?move-in=2022-06-30",
    permonth: "/month",
    id: 40,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/5f14aad3ebf2692cea5f325a30af9781cbbeed6fc8ab1d5d34627546.jpg",
    type: "Room",
    available: "From 27 June",
    title: "Room for rent in apartment with 4 bedrooms in Rome",
    rent: "370 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/457457?move-in=2022-06-30",
    permonth: "/month",
    id: 41,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/5d84508098d20802d80fab898879830d1835410ed0f94edcec3873a4.jpg",
    type: "Room",
    available: "From 1 May",
    title: "Tidy room for rent in 3-bedroom apartment in Tor Vergata",
    rent: "375 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/406513?move-in=2022-06-30",
    permonth: "/month",
    id: 42,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/5d84508098d20802d80fab898879830d1835410ed0f94edcec3873a4.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Tidy room for rent in 3-bedroom apartment in Tor Vergata",
    rent: "375 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/406699?move-in=2022-06-30",
    permonth: "/month",
    id: 43,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/adb1f713cdaec6422619e29b048b99e61684ebbb1cfc9ee73a1d1dab.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Tidy room for rent in 3-bedroom apartment in Tor Vergata",
    rent: "375 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/406460?move-in=2022-06-30",
    permonth: "/month",
    id: 44,
  },
  {
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/5cca299ddb0ddb3788167cbfb711a9dca90d90bbea60e44d898a9555.jpg",
    type: "Room",
    available: "From 1 May",
    title: "Room for rent in room with 2 bedrooms in Rome",
    rent: "380 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/482111?move-in=2022-06-30",
    permonth: "/month",
    id: 45,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/6c569c3b42d5c426e4180916be1ffd43a0548debb67cfb2de8d31604.jpg",
    type: "Room",
    available: "From 1 May",
    title: "Central room with shelving in apartment in Massimilla, Rome",
    rent: "380 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/121258?move-in=2022-06-30",
    permonth: "/month",
    id: 46,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/79d46ffcfda7f419d48709c2d44fb33e805b6ad259e41b67ee41d8a9.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Furnished room in 4-bedroom apartment in Ostiense, Rome",
    rent: "380 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/113841?move-in=2022-06-30",
    permonth: "/month",
    id: 47,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/6f6bd5784af1ea75a92ec9ddcfed4b3073540c564da835148749f7da.jpg",
    type: "Room",
    available: "From 16 June",
    title: "Room for rent in apartment with 4 bedrooms in Rome",
    rent: "380 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/607741?move-in=2022-06-30",
    permonth: "/month",
    id: 48,
  },
  {
    veified: "CHECKED",
    type: "Room",
    available: "From 16 June",
    title: "Large room in 6-bedroom apartment in Ostiense, Rome",
    rent: "385 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/296852?move-in=2022-06-30",
    permonth: "/month",
    id: 49,
  },
  {
    veified: "CHECKED",
    type: "Room",
    available: "From 16 May",
    title: "Room for rent in 6-bedroom apartment in Nomentano, Rome",
    rent: "390 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/155814?move-in=2022-06-30",
    permonth: "/month",
    id: 50,
  },
  {
    veified: "CHECKED",
    type: "Room",
    available: "From 1 June",
    title: "Spacious room in apartment in Torrevecchia, Rome",
    rent: "390 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/94771?move-in=2022-06-30",
    permonth: "/month",
    id: 51,
  },
  {
    veified: "CHECKED",
    type: "Room",
    available: "From 1 June",
    title: "Room for rent in 6-bedroom apartment in Nomentano, Rome",
    rent: "390 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/165779?move-in=2022-06-30",
    permonth: "/month",
    id: 52,
  },
  {
    veified: "CHECKED",
    type: "Room",
    available: "From 3 June",
    title: "Room for rent in 2-bedroom apartment in Tuscolano, Rome",
    rent: "390 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/159835?move-in=2022-06-30",
    permonth: "/month",
    id: 53,
  },
  {
    veified: "CHECKED",
    type: "Room",
    available: "From 16 June",
    title: "Double bedroom for rent 3-bedroom apartment, Rome",
    rent: "390 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/149411?move-in=2022-06-30",
    permonth: "/month",
    id: 54,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/d72043661df43cf0808e8aba93da963acafbc904ad393b3e71230d91.jpg",
    type: "Room",
    available: "From 16 June",
    title: "Rooms for rent in 6-bedroom apartment in Policlinico, Rome",
    rent: "390-655 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/209598?move-in=2022-06-30",
    permonth: "/month",
    id: 55,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/84ddde4e4a8e9f2eb7a878baff8781dd52c83920a85de733d96cdf0d.jpg",
    type: "Room",
    available: "From 24 June",
    title: "Double room for rent in Torre Gaia, Rome",
    rent: "390 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/165675?move-in=2022-06-30",
    permonth: "/month",
    id: 56,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/71a8b18e8c80561cd6a64c9f9240cd880999b20258a7969713ab7488.jpg",
    type: "Room",
    available: "From 27 June",
    title: "Room to rent in apartment with 7 rooms in Rome",
    rent: "390 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/338559?move-in=2022-06-30",
    permonth: "/month",
    id: 57,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/dd1cfb807d0ed1fd81f20fb8f03efa0b2e39842eccab8698819eb9a1.jpg",
    type: "Room",
    available: "From 1 May",
    title: "Bright room for rent in 3-bedroom apartment in Tor Vergata",
    rent: "395 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/406668?move-in=2022-06-30",
    permonth: "/month",
    id: 58,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/435d598fc3e3f866598bc58acf78b822520a3de2a06d61e173b21229.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Bright room for rent in 3-bedroom apartment in Tor Vergata",
    rent: "395 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/406473?move-in=2022-06-30",
    permonth: "/month",
    id: 59,
  },
  {
    veified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/435d598fc3e3f866598bc58acf78b822520a3de2a06d61e173b21229.jpg",
    type: "Room",
    available: "From 1 June",
    title: "Bright room for rent in 2-bedroom apartment in Tor Vergata",
    rent: "395 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/rome/for-rent:rooms/406455?move-in=2022-06-30",
    permonth: "/month",
    id: 60,
  },
];
